// Kept in a leaf module so SQL builders can import the table name without pulling in
// the cashflow projections store (and, through it, the API client).
export const TABLE_NAME = 'cashflow_projections'
